import moment from 'moment';

const SECONDS_IN_MINUTE = 60;

class SessionTimer {
    constructor(sessionLength) {
        this.sessionLength = sessionLength;
        this.countdownTimer = null;
        this.timeoutIn = null;

        // Reset the timer on AJAX completion (if still using legacy ajax calls)
        document.addEventListener('ajaxComplete', () => this.resetTimer());
    }

    resetTimer() {
        const now = moment();
        this.timeoutIn = now.add(this.sessionLength, 'minutes');
    }

    stopTimer() {
        clearInterval(this.countdownTimer);
    }

    startTimer() {
        if (!this.timeoutIn) {
            this.resetTimer();
            return;
        }

        const now = moment();
        const timeLeft = moment(this.timeoutIn).diff(now, 'seconds');

        if (timeLeft <= 0) {
            this.stopTimer();
            this.showSessionExpiredMessage();
            return;
        }

        const minutes = String(Math.floor(timeLeft / SECONDS_IN_MINUTE)).padStart(2, '0');
        const seconds = String(timeLeft % SECONDS_IN_MINUTE).padStart(2, '0');

        this.renderTimer(minutes, seconds);
    }

    showSessionExpiredMessage() {
        this.setVisible('session-expired-message');
        document.getElementById('session-timer').style.display = 'none';
    }

    renderTimer(minutes, seconds) {
        this.setVisible('minutes-delimiter');
        this.setVisible('session-timer-icon');
        this.setVisible('seconds-left');
        this.setVisible('minutes-text');

        document.getElementById('minutes-left').innerHTML = `<span>${minutes}</span>`;
        document.getElementById('seconds-left').innerHTML = `<span>${seconds}</span>`;
    }

    setVisible(id) {
        const element = document.getElementById(id);
        if (element) {
            element.classList.remove('d-none');
        }
    }

    start() {
        this.countdownTimer = setInterval(() => this.startTimer(), 1000);
    }
}

globalThis.SessionTimer = SessionTimer;
export default SessionTimer;
